import PropTypes from 'prop-types';

import styles from './FilterGroup.scss';

const propTypes = {
  header: PropTypes.string,
  children: PropTypes.node,
};

const FilterGroup = (props) => {
  const { children, header } = props;

  if (!children) {
    return false;
  }

  if (header && typeof header !== 'string') {
    return null;
  }

  return (
    <div className={styles.root}>
      <h3 className={styles.header}>{ header }</h3>
      {children}
    </div>
  );
};

FilterGroup.propTypes = propTypes;

export default FilterGroup;
